/*
 * @Description: 360健康视图
 * @Author: huangxueqin
 * @Date: 2024-02-01 014:19:48
 */
import $axios from './axios.js'

const baseUrl = "";
// const baseUrl = "https://ssc.boe.com/v1/medical-api";
// const baseUrl = "https://mhp-copdtest.boe.com.cn/v1/medical-api"

export const micApi = {
  // ------ 2024-09-09 360视图v2 ------------
  /**
   * 获取当前再用信息-单独医院
   */
  getMicUsingSingle(params) {
    return $axios.get(baseUrl+'/v1/webpatient/mic/using/single', params);
  },
  // 获取省市县下拉列表
  getProvincesList(data = {}) {
    return $axios.get(baseUrl+"/v1/webpatient/region/list", {
      params: { ...data }
    });
  },
  /**
   * 获取当前再用信息-全部列表
   */
  getMicUsingList(params) {
    return $axios.get(baseUrl+'/v1/medical-api/mic/using/list', params);
  },
  /**
   * 获取某人签署状态-添加就诊人/挂号
   */
  getMicStatusSingle(params) {
    return $axios.post(baseUrl+'/v1/medical-api/mic/status/single', params);
  },
  /**
   * 获取某人签署状态-进入视图页面
   */
  getMicStatusList(params) {
    return $axios.post(baseUrl+'/v1/medical-api/mic/status/list', params);
  },
  /**
   * 签署单医院
   */
  getMicSignSingle(params) {
    return $axios.post(baseUrl+'/v1/medical-api/mic/sign/single', params);
  },
  /**
   * 签署所有-进入视图页面
   */
  getMicSignList(params) {
    return $axios.post(baseUrl+'/v1/medical-api/mic/sign/list', params);
  },
  /**
   * 获取公钥
   */
  rsaPublic(params) {
    return $axios.get(baseUrl+'/v1/webpatient/rsa/public', params);
  },
  /**
   * 发送短信验证码
   */
  sendCode(params) {
    return $axios.post(baseUrl+'/v1/webpatient/sms/auth/sendCode', params);
  },
  /**
   * 校验短信验证码（是登录接口）
   */
  loginBySmsCode(params) {
    return $axios.post(baseUrl+'/v1/webpatient/user/loginBySmsCode', params);
  },

  // ------ 2024-05-30 360视图v1 ------------
  // 没有选择就诊人时查询
  getMicUsing(data={}){
    return $axios.get(baseUrl+"/v1/medical-api/mic/using", {
      params: { ...data }
    });
  },
  // 选择完就诊人查询签署状态
  getMicStatus(data={}){
    return $axios.post(baseUrl+"/v1/medical-api/mic/status", data);
  },
  // 签署
  getMicSign(data={}){
    return $axios.post(baseUrl+"/v1/medical-api/mic/sign",data);
  },
  // 获取360视图参数
  getMicCivlink(data={}){
    return $axios.post(baseUrl+"/v1/medical-api/civlink/params",data);
  },
}